import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useForm } from 'react-hook-form';
import './ReviewForm.css'; // Assuming you have a separate CSS file for styling
import SignupPage from '../Transport Account/SignupForm';

const ReviewForm = () => {
  const [carMakes, setCarMakes] = useState([]);
  const [rating, setRating] = useState(0);
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);

  // useForm hook for managing form state and validation
  const { 
    register, 
    handleSubmit, 
    trigger, 
    formState: { errors } 
  } = useForm();

  // Form submission logic
  const onSubmit = async (data) => {
    try {
      
      
      // Combine form data with rating
      const formData = {
        Name: data.reviewPerson, // Match 'reviewPerson' to 'Name'
        feedback: data.reviewContent, // Match 'reviewContent' to 'feedback'
        rating, // Include the rating value
      };
      setLoading(true);
      // Send the formData to the API using axios
      const response = await axios.post('https://zoomautos.co.uk/api/reviews', formData);
  
      if (response.status === 201) {
        // Handle successful response (e.g., show a success message)
        
    setLoading(false);
    setSuccess(true);
        console.log('Review submitted successfully:', response.data);
        
        window.location.reload();

      }
    } catch (error) {
      // Handle error response (e.g., show an error message)
      console.error('Error submitting review:', error);
      alert('There was an error submitting your review. Please try again.');
    }
  };
  

  return (
    <div className="review-form">
      <h2 style={{ color: '#01103b' }}>Write A Review</h2>
      
      <form onSubmit={handleSubmit(onSubmit)}>
        <label htmlFor="reviewPerson">Your Name</label>
        <input
          type="text"
          id="reviewPerson"
          placeholder="Enter Your Name"
          {...register('reviewPerson', { required: 'Review title is required' })}
        />
        {errors.reviewTitle && (
          <p className="error-message">{errors.reviewTitle.message}</p>
        )}

        <textarea
          placeholder="Tip: Ideal length for a good review is 200 to 350 words. Use minimum 50 words."
          rows="5"
          {...register('reviewContent', {
            required: 'Review content is required',
            minLength: { value: 50, message: 'Review must be at least 50 words' },
          })}
        />
        {errors.reviewContent && (
          <p className="error-message">{errors.reviewContent.message}</p>
        )}


<label style={{ 
  display: 'flex',
  justifyContent: 'center',  // Correct capitalization
  alignSelf: 'center'
}}>Car Rating</label>
        <div className="rating" style={{ alignSelf: 'center' }}>
          {[1, 2, 3, 4, 5].map((star) => (
            <span
              key={star}
              onClick={() => setRating(star)}
              style={{ cursor: 'pointer', color: star <= rating ? '#e80f17' : 'gray' }}
            >
              ★
            </span>
          ))}
        </div>

        <div style={{ display: 'flex', justifyContent: 'center' }}>
  <button type="submit" className="contact-button">
    Submit
  </button>
</div>

      </form>
      {loading && (
        <div className='overlayStyle'>
          <div className='loadingStyle'  >Submitting...</div>
        </div>
      )}

      {/* Success Overlay */}
      {success && (
        <div className='overlayStyle'>
          <div className='successStyle' >Thanks for Submitting your Review It means alot for us!!</div>
        </div>
      )}
      
    </div>
  );
};

export default ReviewForm;
